module.exports = __webpack_public_path__ + "img/frame (3).7af0718a.jpg";